import ChatBubble from 'components/Global/ChatBubble';
import ModelPicker from './ModelPicker';
import styles from './index.module.scss';

// The chat page. It owns the page furniture — the model picker and the column
// the conversation sits in — and hands everything else to ChatBubble in its
// embedded mode: the thread, the composer, attachments, voice input, drag and
// drop, and every action card. One implementation, rendered docked here and
// floating everywhere else, so the two can never drift apart.
const ChatSurface = () => (
	<div className={styles.surface}>
		<div className={styles.surface__bar}>
			<ModelPicker />
		</div>
		<div className={styles.surface__chat}>
			<ChatBubble embedded />
		</div>
	</div>
);

export default ChatSurface;
